module.exports = __webpack_public_path__ + "static/media/northville-hills-bylaws.dd850f35.pdf";